import { render, staticRenderFns } from "./PLPCareplanUsps.vue?vue&type=template&id=37cfa3e6&scoped=true&"
import script from "./PLPCareplanUsps.vue?vue&type=script&lang=ts&"
export * from "./PLPCareplanUsps.vue?vue&type=script&lang=ts&"
import style0 from "./PLPCareplanUsps.vue?vue&type=style&index=0&id=37cfa3e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cfa3e6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsCheckmark16px: require('/var/www/packages/theme/components/icons/checkmark/Checkmark16px.vue').default})
